module.exports = __webpack_public_path__ + "static/media/drone-674235_640.70617bdc.jpg";